export default "__VITE_ASSET__79890c92__"